export enum HsGeometryType {
  Triangles,
  Lines,
  Points,
  Sprite,
}
